export default __webpack_public_path__ + "static/media/layer5.60dc458e.webp";